import Image from 'next/image';
import { memo, useMemo } from 'react';
import { addProtocolToLink } from '../../../../helpers/addProtocolToLink';
import {
  IDetailProfileInfoFC as IWebsiteProps,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import ProfileInfoEditButton from '../button/ProfileInfoEditButton';

const WebsiteComponent: React.FC<IWebsiteProps> = ({
  data,
  roleView,
  setModal,
}) => {
  const item = useMemo(() => data, [data]);

  return (
    <div className="flex justify-between items-center py-4 bg-[#2691BD]/[4%] rounded-[10px] px-3">
      <a
        href={addProtocolToLink(item.link)}
        target="_blank"
        className="cursor-pointer flex items-center overflow-hidden w-full"
        rel="noreferrer"
      >
        <Image
          alt=""
          className="flex-shrink-0 w-[20px]"
          src="/icons/earth.svg"
          width={20}
          height={20}
        />
        <p className="text-[#333333] text-[14px] line-clamp-1 flex-1 px-5">
          {item.link}
        </p>
      </a>
      <ProfileInfoEditButton
        value={item}
        roleView={roleView}
        modalName={UserSettingEnum.Website}
        setModal={setModal}
      />
    </div>
  );
};

export default memo(WebsiteComponent);
